// note: the sum of the two values below must equal 100%
export const HALF_SIZE_VARIANT_TEXTBOX_WIDTH = '35%';
export const HALF_SIZE_VARIANT_IMAGE_WIDTH = '65%';

export const BIG_VARIANT_ASPECT_RATIO = ['3 / 2', null, '8 / 3'];
export const SLIM_VARIANT_ASPECT_RATIO = ['2 / 1', null, '4 / 1'];
